/* tslint:disable */
/* eslint-disable */
/**
 * Strømbestilling API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Hva sikringen omfatter
 * @export
 */
export const SikringOmfangType = {
    Maalepunkt: 'MAALEPUNKT',
    Kunde: 'KUNDE'
} as const;
export type SikringOmfangType = typeof SikringOmfangType[keyof typeof SikringOmfangType];


export function instanceOfSikringOmfangType(value: any): boolean {
    for (const key in SikringOmfangType) {
        if (Object.prototype.hasOwnProperty.call(SikringOmfangType, key)) {
            if (SikringOmfangType[key as keyof typeof SikringOmfangType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SikringOmfangTypeFromJSON(json: any): SikringOmfangType {
    return SikringOmfangTypeFromJSONTyped(json, false);
}

export function SikringOmfangTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): SikringOmfangType {
    return json as SikringOmfangType;
}

export function SikringOmfangTypeToJSON(value?: SikringOmfangType | null): any {
    return value as any;
}

export function SikringOmfangTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): SikringOmfangType {
    return value as SikringOmfangType;
}

